module.exports = __webpack_public_path__ + "static/assets/19725087656ad7fa8228060ca86306a7.png";